import React, { useState } from 'react';
import { 
  View, 
  Text, 
  ScrollView, 
  StyleSheet, 
  Image, 
  TouchableOpacity, 
  Linking, 
  Alert 
} from 'react-native';
import { Card, Title, Paragraph } from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialIcons';
import { clientesMock } from '../../data/clientesMock';
import axios from 'axios';

const ScoreCircle = ({ score }) => {
  let color = '#FF4136'; // Vermelho para score baixo

  if (score >= 80) {
    color = '#2ECC40'; // Verde para score alto
  } else if (score >= 50) {
    color = '#FF851B'; // Laranja para score médio
  }

  return (
    <View style={[styles.scoreCircle, { backgroundColor: color }]}>
      <Text style={styles.scoreText}>{score}%</Text>
    </View>
  );
};

export default function DetalheClienteScreen({ route, navigation }) {
  const { clienteId } = route.params;
  const cliente = clientesMock.find(c => c.id === clienteId) || {
    id: 0,
    razao: 'Smart BR APPs',
    cnpj: '19.422.018/0001-00',
    qtdTitulos: 0,
    valorTotal: 0,
    pontualidade: 100,
    titulosAtrasados: 0
  };

  const [fotoEmpresa] = useState(
    'https://media.gettyimages.com/id/172784129/pt/foto/modern-supermercado.jpg?s=612x612&w=gi&k=20&c=ywFjmVQkQQeiEVzYAFco1xyEL5C7lZq_sfC1m808BPg='
  );

  const [analiseIA, setAnaliseIA] = useState(null);
  const [carregandoAnalise, setCarregandoAnalise] = useState(false);

  const openPDF = (url) => {
    Linking.openURL(url).catch((err) => {
      console.error('Erro ao abrir URL:', err);
    });
  };

  const handleConsultaCNPJ = () => {
    navigation.navigate('DetalhesCNPJ', { cnpj: cliente.cnpj });
  };

  const obterAnaliseIA = () => {
    setCarregandoAnalise(true);
    axios.get(`http://localhost:3007/pontualidade?CODCLI=${route.params.cliente.CODCLI}`)
      .then(resultado => {
        setAnaliseIA(resultado.data.analise);
        setCarregandoAnalise(false);
      })
      .catch(erro => {
        Alert.alert('Erro', 'Não foi possível obter a análise');
        setCarregandoAnalise(false);
      });
  };

  return (
    <ScrollView style={styles.container}>
      {/* Foto de Fachada */}
      <Image 
        source={{ uri: fotoEmpresa }} 
        style={styles.fotoFachada} 
        resizeMode="cover" 
      />

      {/* Dados Gerais */}
      <View style={styles.headerContainer}>
        <Text style={styles.razao}>{cliente.razao}</Text>
        <Text style={styles.cnpj}>CNPJ: {cliente.cnpj}</Text>
      </View>

      {/* Indicadores de Performance */}
      <Card style={styles.performanceCard}>
        <Card.Content>
          <Title style={styles.performanceTitle}>Indicadores de Performance</Title>
          <View style={styles.performanceContainer}>
            <View style={[styles.performanceColumn, styles.empresaColumn]}>
              <View style={styles.columnHeader}>
                <Icon name="work" size={24} color="#007bff" />
                <Text style={styles.columnHeaderText}>Empresa</Text>
              </View>
              <View style={styles.performanceItemContainer}>
                <View style={styles.performanceItem}>
                  <View style={styles.performanceItemIcon}>
                    <Icon name="access-time" size={20} color="#28a745" />
                  </View>
                  <View style={styles.performanceItemContent}>
                    <Text style={styles.performanceItemLabel}>Pontualidade</Text>
                    <Text style={styles.performanceItemValue}>{cliente.pontualidade}%</Text>
                  </View>
                </View>
                <View style={styles.performanceItem}>
                  <View style={styles.performanceItemIcon}>
                    <Icon name="description" size={20} color="#dc3545" />
                  </View>
                  <View style={styles.performanceItemContent}>
                    <Text style={styles.performanceItemLabel}>Títulos em Atraso</Text>
                    <Text style={styles.performanceItemValue}>{cliente.titulosAtrasados}</Text>
                  </View>
                </View>
                <View style={styles.performanceItem}>
                  <View style={styles.performanceItemIcon}>
                    <Icon name="attach-money" size={20} color="#ffc107" />
                  </View>
                  <View style={styles.performanceItemContent}>
                    <Text style={styles.performanceItemLabel}>Valor em Atraso</Text>
                    <Text style={styles.performanceItemValue}>
                      R$ {
                        cliente.qtdTitulos > 0
                          ? Math.round(
                              (cliente.titulosAtrasados / cliente.qtdTitulos) * cliente.valorTotal
                            ).toLocaleString()
                          : '0'
                      }
                    </Text>
                  </View>
                </View>
              </View>
            </View>
            <View style={[styles.performanceColumn, styles.mercadoColumn]}>
              <View style={styles.columnHeader}>
                <Icon name="public" size={24} color="#17a2b8" />
                <Text style={styles.columnHeaderText}>Mercado</Text>
              </View>
              <View style={styles.performanceItemContainer}>
                <View style={styles.performanceItem}>
                  <View style={styles.performanceItemIcon}>
                    <Icon name="access-time" size={20} color="#28a745" />
                  </View>
                  <View style={styles.performanceItemContent}>
                    <Text style={styles.performanceItemLabel}>Pontualidade</Text>
                    <Text style={styles.performanceItemValue}>95%</Text>
                  </View>
                </View>
                <View style={styles.performanceItem}>
                  <View style={styles.performanceItemIcon}>
                    <Icon name="description" size={20} color="#dc3545" />
                  </View>
                  <View style={styles.performanceItemContent}>
                    <Text style={styles.performanceItemLabel}>Títulos em Atraso</Text>
                    <Text style={styles.performanceItemValue}>1</Text>
                  </View>
                </View>
                <View style={styles.performanceItem}>
                  <View style={styles.performanceItemIcon}>
                    <Icon name="attach-money" size={20} color="#ffc107" />
                  </View>
                  <View style={styles.performanceItemContent}>
                    <Text style={styles.performanceItemLabel}>Valor em Atraso</Text>
                    <Text style={styles.performanceItemValue}>
                      R$ {
                        cliente.qtdTitulos > 0
                          ? Math.round(
                              (1 / cliente.qtdTitulos) * 500
                            ).toLocaleString()
                          : '0'
                      }
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
        </Card.Content>
      </Card>

      {/* Análise de IA */}
      <Card style={styles.card}>
        <Card.Content>
          <Title>Análise de Pontualidade com IA</Title>
          {!analiseIA ? (
            <TouchableOpacity 
              onPress={obterAnaliseIA}
              style={styles.botaoAnalise}
            >
              <Text style={styles.textoBotao}>
                {carregandoAnalise ? 'Carregando...' : 'Gerar Análise de IA'}
              </Text>
            </TouchableOpacity>
          ) : (
            <ScrollView style={styles.containerAnalise}>
              <Text>{analiseIA}</Text>
            </ScrollView>
          )}
        </Card.Content>
      </Card>

      {/* Consultas Externas */}
      <Card style={styles.consultasCard}>
        <Card.Content>
          <Title>Consultas Externas</Title>
          <View style={styles.consultaButtons}>
            <TouchableOpacity 
              style={styles.consultaButton}
              onPress={() => openPDF('https://exemplo.com/serasa.pdf')}
            >
              <Text style={styles.consultaButtonText}>Consulta SERASA</Text>
            </TouchableOpacity>
            <TouchableOpacity 
              style={styles.consultaButton}
              onPress={handleConsultaCNPJ}
            >
              <Text style={styles.consultaButtonText}>Consulta CNPJ</Text>
            </TouchableOpacity>
          </View>
        </Card.Content>
      </Card>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f4f4f4'
  },
  fotoFachada: {
    width: '100%',
    height: 250
  },
  headerContainer: {
    padding: 15,
    backgroundColor: 'white'
  },
  razao: {
    fontSize: 20,
    fontWeight: 'bold'
  },
  cnpj: {
    fontSize: 16,
    color: '#666'
  },
  performanceCard: {
    margin: 10
  },
  performanceContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  performanceColumn: {
    flex: 1,
    padding: 10
  },
  empresaColumn: {
    borderRightWidth: 1,
    borderRightColor: '#ccc'
  },
  mercadoColumn: {
    borderLeftWidth: 1,
    borderLeftColor: '#ccc'
  },
  columnHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10
  },
  columnHeaderText: {
    fontSize: 16,
    fontWeight: 'bold',
    marginLeft: 10
  },
  performanceItemContainer: {
    marginBottom: 20
  },
  performanceItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10
  },
  performanceItemIcon: {
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: '#f7f7f7',
    justifyContent: 'center',
    alignItems: 'center'
  },
  performanceItemContent: {
    marginLeft: 10
  },
  performanceItemLabel: {
    fontSize: 14,
    color: '#666'
  },
  performanceItemValue: {
    fontSize: 16,
    fontWeight: 'bold'
  },
  consultasCard: {
    margin: 10
  },
  consultaButtons: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginTop: 10
  },
  consultaButton: {
    backgroundColor: '#007bff',
    padding: 10,
    borderRadius: 5
  },
  consultaButtonText: {
    color: 'white',
    fontWeight: 'bold'
  },
  performanceTitle: {
    marginBottom: 10
  },
  card: {
    margin: 10
  },
  botaoAnalise: {
    backgroundColor: '#007bff',
    padding: 10,
    borderRadius: 5,
    alignItems: 'center'
  },
  textoBotao: {
    color: 'white',
    fontWeight: 'bold'
  },
  containerAnalise: {
    padding: 10
  }
});
